<template>
  <v-flex x16 class="sortable-handler">
    <v-card>
     
      <v-dialog v-model="showModal" hide-overlay transition="dialog-bottom-transition" class="sortable-handler" persistent>
          <v-card>
            <v-toolbar dark style="background-color:#138315">
                <v-toolbar-title>Edit User</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items class="hidden-sm-and-down">
                <v-btn icon dark @click="$emit('close-modal-edit-user')">
                    <v-icon>close</v-icon>
                </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-layout row wrap class="pa-4">
                <v-flex xs12 class="pa-1">
                <v-card class="pa-2">
                    <h4>Edit User</h4>
                    <v-form ref="storeData" @submit.prevent="updateUser()">
                      <v-select
                        :items="listOfClients"
                        item-text="name"
                        v-model="form.client"
                        label="Select a Client for User"
                        return-object
                        v-if="currentUser.role == 'admin'"
                        disabled
                      ></v-select>
                    
                      <v-text-field
                        v-model="form.name"
                        label="Name"
                        v-validate="'required|max:75'"
                        :error-messages="errors.collect('name')"
                        data-vv-name="name"
                      > </v-text-field>

                      <v-text-field
                        v-model="form.email"
                        label="Email"
                        :error-messages="errors.collect('email')"
                        data-vv-name="email"
                      > </v-text-field>

                      <v-text-field
                        class="mb-0 mt-0"
                        v-model="form.password"
                        label="Password"
                        :error-messages="errors.collect('password')"
                        data-vv-name="password"
                        type="password"
                      > </v-text-field>

                      <v-select
                          :items="listOfRoles"
                          v-model="form.role"
                          label="Select a Role for User"
                          disabled
                      ></v-select>
                      
                      <v-flex class="text-xs-right" shrink>
                        <v-btn
                          color="primary"
                          dark
                          class="text-md-left text-sm-left"
                          type="submit"
                        > Update </v-btn>
                      </v-flex>
                    </v-form>
                </v-card>
                </v-flex>
            </v-layout>
          </v-card>
      </v-dialog>
    </v-card>
  </v-flex>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'CreateUser',
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      form: {
        name: '',
        email: '',
        client: null,
        password: null,
        role: 'client',
      },
      listOfClients: [],
      listOfRoles: ['client', 'manager']
    };
  },
  computed: {
    ...mapGetters(['currentUser']),
  },
  mounted () {
    this.getUser();
    this.loadClients();
  },
  methods: {
    loadClients () {
      this.$store.dispatch('setLoading', true);
      let url = '/clients/list';
      window.axios.get(url).then((response) => {
        this.listOfClients = response.data.data;
        this.$store.dispatch('setLoading', false);
      });
    },
    getUser () {
      this.$store.dispatch('setLoading', true);
      let url = '/users/' + this.user.id;
      window.axios.get(url).then((response) => {
        let data = response.data.data;
        this.form.name = data.name;
        this.form.email = data.email;
        this.form.client = data.client;
        this.form.role = data.role;
      });
      this.$store.dispatch('setLoading', false);
    },
    updateUser () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store.dispatch('setLoading', true);
          let url = '/users/' + this.user.id;
          let payload = {
            name: this.form.name,
            email: this.form.email,
            client: null,
            password: this.form.password,
            role: this.form.role
          };

          window.axios.put(url, payload).then((response) => {
            this.$store.dispatch('setSnackbar', {
              show: true,
              color: 'success',
              text: 'User updated suscessfully'
            });
            this.$store.dispatch('setLoading', false);
            this.$emit('update-users');
          }).catch(error => {
            this.$store.dispatch('setLoading', false);
            this.$store.dispatch('setSnackbar', {
              show: true,
              color: 'danger',
              text: 'Check the form, please.'
            });
          });
        }
      });
      this.$emit('update-users');
    }
  }
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/commons/users/modals/Edit.vue